export default __webpack_public_path__ + "static/blight-31d0e087f0272bc5ffddd5b321b82beb.jpg";